import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
const Toaster = ({ ...props }) => {
    const { theme = "system" } = useTheme();
    return (<Sonner theme={theme} className="va-toast-viewport" toastOptions={{
            classNames: {
                toast: "va-toast",
                description: "va-card-description",
                actionButton: "va-button",
                cancelButton: "va-button va-button--outline",
            },
        }} {...props}/>);
};
export { Toaster, toast };
